import React, { useEffect } from 'react'
import { Link } from 'gatsby'
import { Flex, useColorMode, Image } from 'theme-ui'

import Text from '~/components/IntlComponents/Text'
import { GenericSectionDivider } from '~/components/Generic/SectionDivider'
import { useTranslate } from '@chordcommerce/gatsby-theme-autonomy'
import { toURL } from '~/utils/intl/localePrefix'

const CustomErrorPage = () => {
  const [, setColorMode] = useColorMode()
  const translate = useTranslate()

  useEffect(() => {
    setColorMode('Gift-Flow')
  }, [])

  const dividerStyle = {
    transform: [
      'scale(150%, 40%) translateX(-10%)',
      'scale(150%, 20%) translateX(-10%)',
    ],
    marginTop: -82,
    marginBottom: [-20, -32],
    width: ['100%', '100%'],
    shapeRendering: 'crispEdges',
    backgroundColor: 'middleBackground',
  }

  const boxStyle = {
    justifyContent: 'center',
    marginTop: ['-51px'],
    padding: '0 40px',
    position: 'relative',
    color: 'secondary',
    backgroundColor: 'middleBackground',
  }

  const cardStyle = {
    flexFlow: 'column wrap',
    justifyContent: 'space-between',
    textAlign: 'center',
    border: '1px solid',
    borderColor: 'background',
    width: 750,
    padding: 30,
    borderRadius: 8,
    margin: ['20px 0 60px 0', '60px 0 80px 0'],
  }

  const imageStyle = {
    width: [150, 195],
    objectFit: 'contain',
    margin: '0 auto',
  }

  const titleStyle = {
    fontFamily: 'Sofia-Pro',
    fontSize: [18, 20],
    margin: ['10px 0', '14px 0'],
    color: 'background',
  }

  const contactStyle = {
    textDecoration: 'underline',
    textTransform: 'lowercase',
  }

  return (
    <>
      <GenericSectionDivider sx={dividerStyle} fill={'#00E0BE'} />
      <Flex sx={boxStyle}>
        <Flex sx={cardStyle}>
          <Image sx={imageStyle} src="/images/sad-mac.png" alt="sad macaroni" />
          <Text sx={titleStyle}>
            {translate('custom_error.process_failed', {
              contact_link: (
                <Link to={toURL('/contact')}>
                  <Text sx={contactStyle}>
                    {translate('gifting_flow.contact_us')}
                  </Text>
                </Link>
              ),
            })}
          </Text>
        </Flex>
      </Flex>
    </>
  )
}

export default CustomErrorPage
